<template>
  <div>
    <section class="content-header custom-header">
      <h1>{{LangSelected.Interno.EnvioFacturas.Titulo}}</h1>
		</section>
    <section class="content container-fluid">
      <div class="box">
        <div class="form-horizontal">
          <div class="box-body">
            <div class="row">
							<div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
								<span class="col-sm-4 span-label" style="padding-top: 0px;">{{LangSelected.Interno.EnvioFacturas.OrdenCompra}}</span>
								<div class="col-sm-8">
                  <div class="value">
                    <DxTextBox
                      v-model="txtOC"
                      :max-length="40"
                      value-change-event="keyup"
                      :disabled="true"
                    />
                  </div>
								</div>
							</div>
							<div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
								<span class="col-sm-4 span-label" style="padding-top: 0px;">{{LangSelected.Interno.EnvioFacturas.Moneda}}</span>
								<div class="col-sm-8">
                  <DxTextBox
                    v-model="txtId_Moneda"
                    :max-length="40"
                    value-change-event="keyup"
                    :disabled="true"
                  />
								</div>
							</div>
						</div>
						<div class="row">
							<div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
								<span class="col-sm-4 span-label" style="padding-top: 0px;">{{LangSelected.Interno.EnvioFacturas.FechaReqSitio}}</span>
								<div class="col-sm-8">
									<DxTextBox
                    v-model="txtFechaReqEnSitio"
                    :max-length="40"
                    value-change-event="keyup"
                    :disabled="true"
                  />
								</div>
							</div>
							<div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
								<span class="col-sm-4 span-label" style="padding-top: 0px;">{{LangSelected.Interno.EnvioFacturas.Subtotal}}</span>
								<div class="col-sm-8">
									<DxTextBox
                    v-model="txtSubtotal"
                    :max-length="40"
                    value-change-event="keyup"
                    :disabled="true"
                  />
								</div>
							</div>
						</div>
						<div class="row">
							<div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
								<span class="col-sm-4 span-label" style="padding-top: 0px;">{{LangSelected.Interno.EnvioFacturas.Comprador}}</span>
								<div class="col-sm-8">
									<DxTextBox
                    v-model="txtNombreComprador"
                    :max-length="40"
                    value-change-event="keyup"
                    :disabled="true"
                  />
								</div>
							</div>
							<div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
								<span class="col-sm-4 span-label" style="padding-top: 0px;">{{LangSelected.Interno.EnvioFacturas.Impuestos}}</span>
								<div class="col-sm-8">
									<DxTextBox
                    v-model="txtImpuestos"
                    :max-length="40"
                    value-change-event="keyup"
                    :disabled="true"
                  />
								</div>
							</div>
						</div>
						<div class="row">
							<div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
								<div style="height: 24px;"></div>
							</div>
							<div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
								<span class="col-sm-4 span-label" style="padding-top: 0px;">{{LangSelected.Interno.EnvioFacturas.Total}}</span>
								<div class="col-sm-8">
									<DxTextBox
                    v-model="txtTotal"
                    :max-length="40"
                    value-change-event="keyup"
                    :disabled="true"
                  />
								</div>
							</div>
						</div>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="form-horizontal">
          <div class="box-body">
            <DxDataGrid
              id="gridContainer"
              :data-source="EnvioFacturas"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              :column-auto-width="true"
              :show-borders="true"
              key-expr="id"
            >
              <DxColumnChooser :enabled="false"/>
              <DxColumnFixing :enabled="true"/>
              <!--<DxSelection mode="single"/>-->
              <DxFilterRow :visible="true"/>
              <DxPaging :page-size="6"/>
              <DxPager
                :show-page-size-selector="true"
                :allowed-page-sizes="[6, 10, 20]"
              />
              <DxColumn
                :caption="LangSelected.Interno.EnvioFacturas.Concepto"
                data-field="HitoDePago"
                alignment="left"
                :allow-editing="false"
              />
              <DxColumn
                caption="%"
                data-field="Porcentaje"
                data-type="number"
                alignment="center"
                :allow-editing="false"
              />
              <DxColumn
                :caption="LangSelected.Interno.EnvioFacturas.Monto"
                data-field="MontoHito"
                data-type="number"
                format="currency"
                alignment="center"
                :allow-editing="false"
              />
              <DxColumn
                :caption="LangSelected.Interno.EnvioFacturas.Facturado"
                data-field="Facturado"
                data-type="number"
                format="currency"
                alignment="center"
                :allow-editing="false"
              />
              <DxColumn
                :caption="LangSelected.Interno.EnvioFacturas.PorFacturar"
                data-field="PorFacturar"
                data-type="number"
                format="currency"
                alignment="center"
                :allow-editing="false"
              />
              <DxColumn
                :caption="LangSelected.Interno.EnvioFacturas.Factura"
                data-field="BotonVisible"
                alignment="center"
                :width="125"
                :allow-filtering="false"
                cell-template="cellTemplate"
              />
              <template #cellTemplate={data}>
                <span class="button-span-subir" v-if="data.value" @click="upFile(data)" v-b-modal.modal-1>{{LangSelected.Interno.EnvioFacturas.Subir}}</span>
                <!--<span class="button-span-subir" v-if="data.value" @click="upFile(data.key)" data-toggle="modal" data-target="#notificacionesUsuariosModal" data-backdrop="static" data-keyboard="false">Subir</span>-->
              </template>
            </DxDataGrid>
          </div>
        </div>
      </div>
    </section>
    <b-modal id="modal-1" ref="modal-1" title="Orden Compra" size="lg" button-size="sm" :no-close-on-esc="true" :no-close-on-backdrop="true" style="width:90%;">
      <div class="modal-body" style="padding-top: 0px; padding-bottom: 0px; padding:0px;">
        <div class="box box-default box-solid" style="margin-bottom: 4px;margin-top: 4px;">
          <div class="box-body">
            <div class="row">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
              <DxDataGrid
                id="gridPopUpContainer"
                :data-source="TotalesConImpuesto"
                :allow-column-resizing="true"
                :column-auto-width="true"
                :show-borders="true"
                key-expr="ID"
              >
                <DxColumn 
                  :caption="LangSelected.Interno.EnvioFacturas.TotalesConImpuesto"
                  data-field="TotalesImpuesto"
                  alignment="left"
                />
                <DxColumn
                  :caption="LangSelected.Interno.EnvioFacturas.Monto"
                  data-field="Monto"
                  data-type="number"
                  format="currency"
                  alignment="center"
                />
                <DxColumn
                  :caption="LangSelected.Interno.EnvioFacturas.Facturado"
                  data-field="Facturado"
                  data-type="number"
                  format="currency"
                  alignment="center"
                />
                <DxColumn
                  :caption="LangSelected.Interno.EnvioFacturas.PorFacturar"
                  data-field="PorFacturar"
                  data-type="number"
                  format="currency"
                  alignment="center"
                />
                <DxColumn
                  :caption="LangSelected.Interno.EnvioFacturas.Moneda"
                  data-field="Moneda"
                  alignment="left"
                />
              </DxDataGrid>
             </div>
            </div>
            <div class="row" style="margin-top:20px;">
              <div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                <span class="col-sm-4 span-label" style="padding-top: 0px;">{{LangSelected.Interno.EnvioFacturas.ArchivoXML}}</span>
                <div class="col-sm-8">
                  <div class="value">
                    
                  </div>
                </div>
              </div>
              <div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                <span class="col-sm-4 span-label" style="padding-top: 0px;"></span>
                <div class="col-sm-8">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                <span class="col-sm-4 span-label" style="padding-top: 0px;">{{LangSelected.Interno.EnvioFacturas.ArchivoPDF}}</span>
                <div class="col-sm-8">
                  <div class="value">
                    
                  </div>
                </div>
              </div>
              <div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                <span class="col-sm-4 span-label" style="padding-top: 0px;">Subtotal</span>
                <div class="col-sm-8">
                  <DxNumberBox
                    v-model="selSubtotal"
                    :min="0"
                    :show-spin-buttons="true"
                    :show-clear-button="true"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                <span class="col-sm-4 span-label" style="padding-top: 0px;">{{LangSelected.Interno.EnvioFacturas.NumFactura}}</span>
                <div class="col-sm-8">
                  <div class="value">
                    <DxTextBox
                      v-model="selNumFactura"
                      :max-length="40"
                      value-change-event="keyup"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                <span class="col-sm-4 span-label" style="padding-top: 0px;">{{LangSelected.Interno.EnvioFacturas.Impuesto}}</span>
                <div class="col-sm-8">
                  <DxNumberBox
                    v-model="selImpuestos"
                    :min="0"
                    :show-spin-buttons="true"
                    :show-clear-button="true"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                <span class="col-sm-4 span-label" style="padding-top: 0px;">{{LangSelected.Interno.EnvioFacturas.FechaFactura}}</span>
                <div class="col-sm-8">
                  <div class="value">
                    <date-picker v-model="selFechaFacturaStr" valueType="format" :format="dateFormat"></date-picker>
                    <!--<DxDateBox
                      v-model="selFechaFacturaStr"
                      display-format="dd-MMM-yyyy"
                      type="date"
                      visible="false"
                    />-->
                  </div>
                </div>
              </div>
              <div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                <span class="col-sm-4 span-label" style="padding-top: 0px;">{{LangSelected.Interno.EnvioFacturas.TotalFactura}}</span>
                <div class="col-sm-8">
                  <DxNumberBox
                    v-model="selTotal"
                    :min="1"
                    :show-spin-buttons="true"
                    :show-clear-button="true"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                <span class="col-sm-4 span-label" style="padding-top: 0px;">{{LangSelected.Interno.EnvioFacturas.Referencia}}</span>
                <div class="col-sm-8">
                  <div class="value">
                    <DxTextBox
                      v-model="selReferencia"
                      :max-length="40"
                      value-change-event="keyup"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                <span class="col-sm-4 span-label" style="padding-top: 0px;">Moneda</span>
                <div class="col-sm-8">
                  <div class="value">
                    <DxTextBox
                      v-model="selId_Moneda"
                      :max-length="40"
                      value-change-event="keyup"
                      :disabled="true"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row" style="margin-top:5px">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <span class="col-sm-2 span-label" style="padding-top: 0px;">{{LangSelected.Interno.EnvioFacturas.Comentarios}}</span>
                <div class="col-sm-10">
                  <div class="value">
                    <DxTextArea
                      :height="90"
                      :max-length="maxLength"
                      v-model="selComentarios"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="secondary" @click="cancel()">
          {{LangSelected.Interno.EnvioFacturas.BtnCancelar}}
        </b-button>
        <b-button size="sm" variant="primary" @click="enviar()">
          {{LangSelected.Interno.EnvioFacturas.BtnEnviar}}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import DxTextBox from 'devextreme-vue/text-box';
  import DxNumberBox from 'devextreme-vue/number-box';
  import DxTextArea from 'devextreme-vue/text-area';
  import apiClient from '@/services/apiClient';
  import notify from 'devextreme/ui/notify';
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import 'vue2-datepicker/locale/es';
  import { 
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxColumnFixing,
    DxPager,
    DxFilterRow,
    DxPaging
  } from 'devextreme-vue/data-grid';
  export default {
    components: {
      DxTextBox,
      DxDataGrid,
      DxColumn,
      DxColumnChooser,
      DxColumnFixing,
      DxPager,
      DxFilterRow,
      DxPaging,
      DxNumberBox,
      DxTextArea,
      //DxDateBox,
      DatePicker 
    },
    data: function() {
      return {
        LangSelected: JSON.parse(localStorage.getItem('languageInfo')),
        txtFechaAprobacionOC: "",
        txtFechaReqEnSitio: "",
        txtId_Moneda: "",
        txtImpuestos: "",
        txtNombreComprador: "",
        txtOC: "",
        txtSubtotal: "",
        txtTotal: "",
        EnvioFacturas:[],
        HeaderPopUp : "Orden Compra",
        maxLength: 50,
        Id_OrdenCompraFecha:null,
        TotalesConImpuesto:[
          { ID : null, TotalesImpuesto : null, Monto : null, Facturado : null, PorFacturar : null, Moneda: null}
        ],
        selSubtotal:null,
        selNumFactura:null,
        selImpuestos:null,
        selFechaFacturaStr:null,
        dateFormat:"DD-MMM-YY",
        selTotal:null,
        selReferencia:null,
        selId_Moneda:null,
        selComentarios:null
      };
    },
    created: function(){
      var that = this;
      if(!that.$route.params.Id_OrdenCompra){
          that.$router.push({name:'OCDocumentacionPendiente', params: {message: 1 }});
      }
      apiClient.get('/api/Facturas/getOC_DatosGenerales', {
        params: {
          Id_OrdenCompra: that.$route.params.Id_OrdenCompra,
          FormatoXML: false
        }
      })
      .then(function (response) {
        that.txtId_Moneda = response.data[0].Id_Moneda;
        that.txtNombreComprador = response.data[0].NombreComprador;
        that.txtFechaAprobacionOC = response.data[0].FechaAprobacionOC;
        that.txtFechaReqEnSitio = response.data[0].FechaReqEnSitio;
        that.txtOC = response.data[0].OC;
        that.txtSubtotal = response.data[0].Subtotal;
        that.txtImpuestos = response.data[0].Impuestos;
        that.txtTotal = response.data[0].Total;
      })
      .catch(function (error) {
        console.log('Error: ' + error);
      });
      apiClient.get('/api/Facturas/getOC_HitosFacturas', {
        params: {
          Id_OrdenCompra: that.$route.params.Id_OrdenCompra,
          FormatoXML: false
        },
        withLenguaje: true
      })
      .then(function (response) {
        that.EnvioFacturas = response.data;
      })
      .catch(function (error) {
        console.log('Error: ' + error);
      });
    },
    methods: {
      upFile:function(registro) {
          var that = this;
          that.TotalesConImpuesto[0].TotalesImpuesto = registro.data.HitoDePago;
          that.TotalesConImpuesto[0].Monto = registro.data.MontoHito;
          that.TotalesConImpuesto[0].Facturado = registro.data.Facturado;
          that.TotalesConImpuesto[0].PorFacturar = registro.data.PorFacturar;
          that.TotalesConImpuesto[0].Moneda = that.txtId_Moneda;
          that.TotalesConImpuesto[0].ID = registro.data.Id;
          that.Id_OrdenCompraFecha = (registro.data.Id)?registro.data.Id:null;
          that.selId_Moneda = that.txtId_Moneda;
          this.HeaderPopUp = "Orden Compra " + that.txtOC;
          //Inputs
          that.selSubtotal=0;
          that.selNumFactura=null;
          that.selImpuestos=0;
          that.selFechaFacturaStr='';
          that.selTotal=0;
          that.selReferencia='';
          that.selComentarios='';
          console.log(registro);
      },
      enviar:function(){
        var that = this;
        var MontoFactura = that.TotalesConImpuesto[0].PorFacturar.replace('$', '');
        MontoFactura = MontoFactura.replace(',', '');
        if(!that.selNumFactura){
          notify('El numero de factura no puede estar vacio', 'error');
        }else{
          if(that.selTotal>=1){// && that.selTotal<=parseFloat(MontoFactura)
            //alert("enviado");
            /*
            that.selComentarios=null;
            */
            apiClient.put('/api/Facturas/updOC_EnviarFactura', {
              Id_OrdenCompraFecha: that.Id_OrdenCompraFecha,
              Id_OrdenCompra: that.$route.params.Id_OrdenCompra,
              NumFactura: that.selNumFactura,
              FechaFacturaStr: that.selFechaFacturaStr,
              Subtotal: that.selSubtotal,
              Impuestos: that.selImpuestos,
              Total: that.selTotal,
              Id_Moneda: that.selId_Moneda,
              Referencia: that.selReferencia || '',
              Comentarios: that.selComentarios || '',
              NombreDocumentoPDF: '',
              NombreDocumentoXML: '',
              FormatoXML: false
            }, { withLenguaje: true })
            .then(function (response) {
              console.log(response.data);
            })
            .catch(function (error) {
              console.log('Error: ' + error);
            });

            this.$refs['modal-1'].hide();
          }else{
            notify('El monto de la factura debe ser mayor a 0 y menor o igual al importe por facturar ('+MontoFactura+')', 'error');
          }
        }
      }
    }
  };
</script>
<style scoped>
.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col, .col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm, .col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md, .col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg, .col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl, .col-xl-auto{
  display: inline-block;
}
</style>